module.exports = __webpack_public_path__ + "static/media/youssef1.14f43731.webp";